import * as React from "react";
import { forwardRef } from "react";
const SvgMinimize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 5, viewBox: "0 0 15 5", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M.931.904h13.887v3.162H.931z" }));
const ForwardRef = forwardRef(SvgMinimize);
export default ForwardRef;
